import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { useDispatch } from "react-redux";
import PipelineTable from "./PipelineTable";
import { mapApiToPipeline } from "./transformHiringPipeline";
import { getData } from "../../../../../../actions/apiCall";

interface DepartmentOption {
  label: string;
  value: string;
}

const departmentOptions = [
  { value: "all", label: "All Departments" },
  { value: "engineering", label: "Engineering" },
  { value: "design", label: "Design" },
  { value: "marketing", label: "Marketing" },
  { value: "sales", label: "Sales" },
];


const HiringPipeline: React.FC = () => {
  const dispatch = useDispatch();

  const [pipelineData, setPipelineData] = useState<any[]>([]);
  const [departments, setDepartments] = useState<DepartmentOption[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<string>("all");

  useEffect(() => {
    fetchPipeline();
    fetchDepartments();
  }, []);

  // ✅ Pipeline API
  const fetchPipeline = async () => {
    const res: any = await dispatch(
      getData("/analytic/deshboard/hiring-pipeline")
    );

    if (res?.data?.data && Array.isArray(res.data.data)) {
      const mappedData = mapApiToPipeline(res.data.data);
      setPipelineData(mappedData);
    }
  };

  // ✅ Department Dropdown API
  const fetchDepartments = async () => {
    const res: any = await dispatch(getData("/departments"));

    console.log("Departments API Response:", res);

    // ✅ CORRECT based on your API
    const departmentList = res?.data;

    if (Array.isArray(departmentList)) {
      const options: DepartmentOption[] = [
        { label: "All Departments", value: "all" },
        ...departmentList.map((dept: any) => ({
          label: dept.name,
          value: dept._id,
        })),
      ];

      setDepartments(options);
    } else {
      console.error("Departments is not an array", departmentList);
    }
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 mt-4  w-full">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">Hiring Pipeline</h2>

        <Select
          className="w-48"
          value={selectedDepartment}
          options={departments}
          onChange={(value) => setSelectedDepartment(value)}
          placeholder="Select Department"
        />
      </div>

      <PipelineTable data={pipelineData} />
    </div>
  );
};

export default HiringPipeline;
